import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../component/shared/shared.service';
import { AuthServiceService } from '../../../component/service/auth-service.service';
import { User } from '../model/user';
import { UserDetail } from '../model/user-detail';
import { Patient } from '../../../section/patient/model/patient';
import { UserService } from '../service/user.service';
import { Appointment, Schedule } from '../../../section/appointment/model/appointment';
import { AppointmentService } from '../../../section/appointment/service/appointment.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {
  authService : AuthServiceService;
  usrData : User ;
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  appointments : Appointment[];
  selectedAppObject : Appointment;
  isSuccessMessage : boolean = false;
  isErrorMessage : boolean = false;
  apploading : boolean = false;
  Users : User[];
  user: any;
  selectedObject : User;
  patientsData: Patient[];
  patientData: Patient;
  isAdd : boolean = true;
  files : any[]=[];
  userClinic= null;
  appDate: any;
  id: number = 0;
  RegistrationNo : string = "";
  private sub: any;
  reviews : any[] = [];
  filesData : any[];
  documents: any[] = [{fileName:'', id:0},{fileName:'', id:0},{fileName:'', id:0}];
  messageText : string="";
  loadingAction : boolean = false;
  isSuperAdmin : boolean = false;
  isDoctor : boolean = false;
  isBDA : boolean = false;
  isAssistant : boolean = false;
  dtOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  constructor(authorizationService : AuthServiceService, private _sharedService: SharedService, private _usrService : UserService,private route: ActivatedRoute, private _appService : AppointmentService) { 
    this.authService = authorizationService;
    let dt = new Date();
    if(this.authService.getUserRole() === "1") {
      this.isSuperAdmin = true;
   } else if(this.authService.getUserRole() === "2") {
     this.isDoctor = true;
   } else if(this.authService.getUserRole() === "3") {
    this.isAssistant = true;
  } else if(this.authService.getUserRole() === "4") {
    this.isBDA = true;
  }

    this.appDate =  { date: { year: dt.getFullYear(), month: dt.getMonth() + 1, day: dt.getDate() } };
    _sharedService.yesEmitted$.subscribe(
      text => {
          if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'DOCAPPOINTMENTCANCELE') {
              this.cancelAppointmentData(this.selectedAppObject);
          } 
          if(text.Action===DialogAction.DELETE.toString() && text.Page==="USERDELETE") {
            this.selectedObject = text.Data;
            this.delete();
        } 
      });
      this.addFiles();
      
  }
  color:string = 'doc-list hoverList';
  defaultStyle:string = 'doc-list outList';
  hoveredDivId :number;
  changeStyle($event, id, index){
    $event.type == 'mouseover' ? this.hoveredDivId = id : this.hoveredDivId = null;      
  }
  setUser (usr : User) : void {
      this.usrData = usr;
      this.RegistrationNo = this.usrData['RegistrationNo'];
      this.getUserDocument(this.usrData.UserId);
      if(this.usrData['UserClinic'] !== null && this.usrData['UserClinic'].length>0) {
        this.userClinic = this.usrData['UserClinic'][0].AssociateClinicId;
        let date = this.appDate.date.year + '-' + this.appDate.date.month + '-'+ this.appDate.date.day;
        this.getAppointmentForDay(date);
      }
     
  }
  getUserDocument(id: number) {
    for(let i=this.documents.length-1; i>=0;i--) {
      this.documents[i].fileName ="";
      this.documents[i].id = 0;
     }
     this._usrService.getUserDocument(id).subscribe(data=>{
       for(let i=data.length-1; i>=0;i--) {
        this.documents[i].fileName = data[i].DegreePath;
        this.documents[i].id = data[i].DegreeAutoId;
       }
         
     })
  }

  deleteDocument(id: number, index: number) {
    this._usrService.deleteUserDocument(id).subscribe(data=>{
        this.documents[index].fileName="";
        this.documents[index].id=0;
    })
 }
  getUsers(id : number) : void {
    /*this.user = JSON.parse(sessionStorage.getItem("User"));
    if(this.user=== undefined || this.user=== null) {
        this.getUserDetail(startDate);
    } else {
       if(this.user.UserRoleId==4 ) {
       }
    }*/

    if(this.isDoctor) {
      this.user = JSON.parse(sessionStorage.getItem("User"));
      if(this.user=== undefined || this.user=== null) {
       this._usrService.getUserProfile().subscribe(data=>{
        if(data.length>0) {
          sessionStorage.setItem("User",JSON.stringify(data[0]));
          this.usrData = data[0];
          this.setUser(this.usrData);
        
        }})
      } else {
        this.usrData = this.user;
        this.hoveredDivId = this.usrData.UserId;
        this.setUser(this.usrData);
      }
    } else {
      this.loading = true;
      this._usrService.getUsers().subscribe(data=>{
        this.loading = false;
        this.Users  = data;
        if(id != undefined && id != null){
            var data = this.Users.filter(function(user){
              return (user.UserId === id);
            })
            if(data.length>0){
              this.usrData = data[0];
              this.hoveredDivId = this.usrData.UserId;
              this.setUser(this.usrData);
              
             
            } 
        }
  
      },
      error=>{
          this.loading = false;
          this.message = error.data;
      });
    }

   
}

  ngOnInit() {
    this.usrData = null;
    var id : number;
    this.id = 0;
    this.sub = this.route.params.subscribe(params => {     
      id = +params['id'];    
      this.id = id;
   });
    this.getUsers(id); 
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  deleteUser(usr : User) :void {
    this.selectedObject = usr;
    this._sharedService.emitDialog(true,"Delete",ActionMessage.DELETE.toString(), true, DialogAction.DELETE.toString(), "USERDELETE", this.selectedObject );   
  }
  delete() : void {
    this.loading = true;
    this._usrService.deleteUser( this.selectedObject).subscribe(data=>{
      this.listLoading = false;
      this.message = "User " + ActionMessage.DELETESUCCESS.toString();
      this.ngOnInit();
    },
    error=>{
        this.loading = false;
        this.message = error.data;
    });
}

onChange(event: EventTarget, index: number) {
  let eventObj: MSInputMethodContext = <MSInputMethodContext> event;
  let target: HTMLInputElement = <HTMLInputElement> eventObj.target;
  let files: FileList = target.files;
  this.files[index].file = files[0];
  this.files[index].text = files[0].name;
  
}
 addFiles() {
    this.files.push({text : '', file : null});
      this.files.push({text : '', file : null});
      this.files.push({text : '', file : null});
      this.files.push({text : '', file : null});
      this.files.push({text : '', file : null});
 }

 updateDocument(no: string, regimg: string, sig: string, index: number) {
  this._usrService.docData = {"UserId" : this.usrData.UserId , "RegistrationNo": no,"RegistrationImage": regimg,"Signature": sig};
  this._usrService.updateDocument().subscribe(data=>{

  })
 }

 saveDocument() {
   this._usrService.docData = {"UserId" : this.usrData.UserId , "REGISTRATIONNO": this.RegistrationNo };
   this.filesData = [];
   
   this.filesData.push({'file':this.files[0].file, 'text': 'DEGREE1'} );
   this.filesData.push({'file':this.files[1].file, 'text': 'DEGREE2'} );
   this.filesData.push({'file':this.files[2].file, 'text': 'DEGREE3'} );
   this.filesData.push({'file':this.files[3].file,  'text': 'REGISTRATION'});
   this.filesData.push({'file':this.files[4].file, 'text': 'SIGNATURE'} );


  this._usrService.document = this.filesData;
  this.loadingAction = true;
  this._usrService.saveDocuments().subscribe(data=>{
    this.messageText = "Document uploaded successfully.";
    this.loadingAction = false;
    this.isSuccessMessage = true; 
    this.files = [];
    this.addFiles();
    this.hideMessage(); 
    this.getUserDocument(this.usrData.UserId);
    this._usrService.getUserProfile().subscribe(data=>{
      if(data.length>0) {
        sessionStorage.setItem("User",JSON.stringify(data[0]));
        this.usrData = data[0];
        this.setUser(this.usrData);
      
      }});
  },
  error=>{
    this.loadingAction = false;
    this.message = error.data;
    this.isErrorMessage = true; 
    this.hideMessage();
    
  });
}
 
  getAppointmentForDay(date:string) : void {
    this.apploading = true;
     this._appService.getDoctorAppointmentForDateRange(this.usrData.UserId, 0, date, date).subscribe(data=>{
       this.appointments = data;
       this.patientsData = [];
       var ptData : any [] = [];
       for(let i=0; i<this.appointments.length; i++) {
          if(ptData.indexOf(this.appointments[i].AppointmentPatientName)==-1) {
            this.patientData = new Patient(this.appointments[i].AppointmentPatientId,this.appointments[i].AppointmentPatientName.split(' ')[0],this.appointments[i].AppointmentPatientName.split(' ')[1],'','',null,'','','','','',this.appointments[i].AppointmentPatientContactNo,null,'',null,this.appointments[i].AppointmentPatientMail,'','','',null,null,'');
            ptData.push(this.appointments[i].AppointmentPatientName);
            this.patientsData.push(this.patientData);

          }
       }
       this.apploading = false;
     },error=>{

     });
  }
  onDateChanged(event: IMyDateModel) {
    if(event.date != null && event.date.year != 0) {
      let date = event.date.year + '/' + event.date.month + '/'+ event.date.day;
      this.getAppointmentForDay(date);
    } else {
       return;
    }
  }
  hideMessage() : void {
    setTimeout(() => {
      this.isErrorMessage  = false;
      this.isSuccessMessage  = false;   
      this.message = '';
      this.loadingAction = false;
      this.messageText ="";
    }, 3000);
  }
  cancelAppointmentData(data : Appointment) {
    this._appService.cancelAppointment(data.AppointmentDoctorId, data.AppointmentClinicId, data.AppointmentDay, data.AppointmentTime ).subscribe(data=>{
        this.isSuccessMessage = true;
        this.hideMessage();
        let date = this.appDate.date.year + '-' + this.appDate.date.month + '-'+ this.appDate.date.day; 
        this.getAppointmentForDay(date);
        this.message = "Appointment canceled successfully";
    }, error=> {
      this.isErrorMessage = true;
      this.message = "Appointment not canceled";
    })
 }
  cancelAppointment(data : Appointment) {
    this.selectedAppObject =data;
    this._sharedService.emitDialog(true, "Deactivate", ActionMessage.CANCEL.toString(),true,DialogAction.DELETE.toString(), 'DOCAPPOINTMENTCANCELE' );  

  }
  bookAppointment(usr : User) {
    this._sharedService.overlay( {'module' :'USER','type' : 'Appointment','isShow' : true,'data' : usr, 'secondData' : null});
  }
  updateDetail(data : Appointment) : void {
    
  }

  showReview() {
    this._usrService.getReviewByDoc(this.selectedObject.UserId).subscribe(data=>{
      this.reviews = data;
     
   },error => {
      
   })
  };
  ApproveReview(rev: any) {
    this._usrService.UpdateReviewStatus({'ReviewStatus' : 1, 'PatientId' : rev.PatientId}).subscribe(data=>{
      
      this.showReview();
   },error => {
      
   })
  } 
  RemoveReview(rev: any) {
    this._usrService.DeleteClientReview(rev.ReviewId).subscribe(data=>{
     
      this.showReview();
   },error => {
      
   })
  }
}



// WEBPACK FOOTER //
// ./src/app/section/user/user-detail/user-detail.component.ts